<template>
  <el-container class="payment">
    <el-header>
      <h4>Payment Authorized</h4>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="8">
          <h6>Payment Authorized</h6>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <h6>Payment Gateways</h6>
        </el-col>
        <el-col :span="12">
          <template v-for="paymentGateway in order.payment_gateway_names">
            <div>{{ paymentGateway | underscoresToSpaces | capitalize }}</div>
          </template>
        </el-col>
      </el-row>
      <OrderUpdatePaymentSubtotal :quantity="quantity" :subtotal="subtotal"/>
      <OrderDiscounts/>
      <OrderShipping/>
      <OrderTaxes/>
      <OrderUpdatePaymentTotal :total="payment.totalPrice"/>
      <hr>
      <OrderUpdatePaymentCustomer
          :total="payment.totalPrice"
          :maxEligibleAmount="maxEligibleAmount"/>
      <OrderUpdatePaymentMaxEligible :maxEligibleAmount="maxEligibleAmount"/>
    </el-main>
  </el-container>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {ORDER_GET_PRODUCTS_SUBTOTAL} from '../../../../store/types';
import {capitalize, underscoresToSpaces,} from '../../../../filters';
import OrderShipping from './OrderUpdatePaymentShipping';
import OrderDiscounts from './OrderUpdatePaymentDiscounts';
import OrderTaxes from './OrderUpdatePaymentTaxes';
import OrderUpdatePaymentSubtotal from './OrderUpdatePaymentSubtotal';
import OrderUpdatePaymentTotal from './OrderUpdatePaymentTotal';
import OrderUpdatePaymentCustomer from './OrderUpdatePaymentCustomer';
import OrderUpdatePaymentMaxEligible from './OrderUpdatePaymentMaxEligible';

export default {
  name: 'OrderPaymentDetails',
  props: {
    payment: {
      type: Object,
      required: true,
      lineItems: {
        type: Array,
        required: true,
      },
      subtotalPrice: {
        required: true,
      },
      taxLines: {
        required: true,
      },
      totalPrice: {
        required: true,
      },
    },
    maxEligibleAmount: {
      required: true,
    },
    quantity: {
      required: true,
    },
    products: {
      type: Object,
      required: true,
    },
  },
  components: {
    OrderShipping,
    OrderDiscounts,
    OrderTaxes,
    OrderUpdatePaymentTotal,
    OrderUpdatePaymentCustomer,
    OrderUpdatePaymentSubtotal,
    OrderUpdatePaymentMaxEligible,
  },
  filters: {
    underscoresToSpaces,
    capitalize,
  },
  computed: {
    ...mapState({
      order: state => state.order.order,
    }),
    ...mapGetters({
      subtotal: ORDER_GET_PRODUCTS_SUBTOTAL,
    }),
  },
};
</script>

<style lang="scss">
.payment {
  h6 {
    margin-bottom: 0;
    margin-top: 0;
  }

  .el-row {
    margin-bottom: 5px;
  }
}
</style>
